var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobconfigPaperNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 1 21)",
    fill: "#F38D33",
    stroke: "#E4E4E4",
    strokeWidth: 0.583587
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.08301 9.66634V12.333C8.08301 13.8216 8.08301 14.5659 8.56851 14.8572C9.05402 15.1485 9.71074 14.7982 11.0242 14.0977L13.5242 12.7644C14.9801 11.9879 15.708 11.5997 15.708 10.9997C15.708 10.3997 14.9801 10.0114 13.5242 9.23497L11.0242 7.90163C9.71074 7.20113 9.05402 6.85088 8.56851 7.14218C8.08301 7.43348 8.08301 8.17777 8.08301 9.66634Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobconfigPaperNext);
export default __webpack_public_path__ + "static/media/jobconfig-paper-next.86a9ad3eb3fed889595cc9db101372eb.svg";
export { ForwardRef as ReactComponent };